<template>
  <v-select
    :items="options"
    item-value="id"
    item-text="value"
    v-model="valueComputed"
    :label="label"
    :rules="[requiredCheck()]"
    :disabled="disabled"
    :clearable="clearable ? clearable : false"
    :readonly="readonly ? readonly : false"
    :dense="dense ? dense : false"
    :hide-details="hideDetails != null ? hideDetails : false"
    outlined
  ></v-select>
</template>

<script>
import { required } from '@/lib/formValidations'

export default {
  props: [
    'value',
    'label',
    'isRequired',
    'disabled',
    'clearable',
    'readonly',
    'dense',
    'hideDetails'
  ],
  data () {
    return {
      options: [
        { id: 1, value: 'Hourly' },
        { id: 2, value: 'Monthly' },
        { id: 3, value: 'Annual' }
      ]
    }
  },
  computed: {
    valueComputed: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('rateTypeChange', newValue)
      }
    }
  },
  methods: {
    requiredCheck () {
      return !this.isRequired || required(this.label ? this.label : 'This Field')
    }
  }
}
</script>
